import West1 from "./1.webp";
import West2 from "./2.webp";
import West3 from "./3.webp";

const West = [West1, West2, West3];

export default West;
